function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "automatic",
  transform: "translate(-3.375 -3.376)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_11566",
  "data-name": "Path 11566",
  d: "M29.25,18h-4.5a2.252,2.252,0,0,0-2.25,2.25v13.5h2.25V28.125h4.5V33.75H31.5V20.25A2.252,2.252,0,0,0,29.25,18Zm-4.5,7.875V20.25h4.5v5.625Z",
  fill: "#ac1ede"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_11567",
  "data-name": "Path 11567",
  d: "M18,30.375A12.359,12.359,0,0,1,7.632,24.75H13.5V22.5h-9v9H6.75V27.354A14.652,14.652,0,0,0,18,32.625Z",
  fill: "#ac1ede"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_11568",
  "data-name": "Path 11568",
  d: "M22.5,11.25h5.867A12.372,12.372,0,0,0,5.625,18H3.375A14.631,14.631,0,0,1,29.25,8.646V4.5H31.5v9h-9Z",
  fill: "#ac1ede"
}));

var SvgAutomatic = function SvgAutomatic(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28.125,
    height: 30.374,
    viewBox: "0 0 28.125 30.374",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAutomatic, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/automatic.a27ed22e.svg";
export { ForwardRef as ReactComponent };